import { Icon } from '@iconify/react';
import React from 'react'

type Props = {
  title: string;
  description: string;
  count: number | string;
  workersOutCount?: number | string;
}

const TeamCard: React.FC<Props> = ({ title, description, count, workersOutCount }) => {
  return (
    <div className='h-24 border flex justify-between border-gray-200 p-3 bg-white rounded-xl w-full shadow-sm'>
      <div className='flex justify-between gap-2'>
        <div className='w-10 h-10 mb-2 flex items-center justify-center bg-gray-200 rounded-lg'>
          <Icon icon="solar:users-group-rounded-bold-duotone" width={20} />
        </div>
        <div>
        <h1 className='text-sm font-medium'> {title}</h1>
         <p className='text-xs'>{description}</p>
        <p className='text-xl font-bold'> <span className='text-red-700'>{workersOutCount}</span> / {Number(count) -Number(workersOutCount)} / {count} </p>
        </div>
      </div>
      <Icon icon="solar:alt-arrow-right-linear" width={20} className='self-center ml-4 text-gray-400'/>
    </div>
  )
}
export default TeamCard
